module.exports = __webpack_public_path__ + "img/silver.610d3788.png";